module.exports = "<thm-content>\n    <router-outlet></router-outlet>\n</thm-content>\n"